define((require) => {
    "use strict";

    const $           = require("jquery");
    const _           = require("underscore");
    const Mousetrap   = require("mousetrap");
    const KeyCode     = require("shared/services/KeyCode");

    const win       = $(window);
    let listeners   = [];

    function setupOn(type) {
        return function(keycode, callback, context) {
            // context is used by listenTo() as the "key" for all event name/callback pair from a particular object.
            // The same key will then be given to off() rather than giving it each event name/callback pair.
            let modifiers;
            let selector;
            let correctModifiers;

            // If the keycode is a string, then it's a list with the key code, modifiers and element selector separated by /.
            // Trying to use a list or an object triggers some annoying method overloading detection in Backbone.
            if (_.isString(keycode)) {
                const blah = keycode.split("/");
                modifiers = blah[1];
                selector = blah[2];
                keycode = parseInt(blah[0], 10);

                if (modifiers) {
                    const modifierNames = [];

                    _.each(["ctrl", "shift", "alt"], (mod) => {
                        if (modifiers.indexOf(mod) !== -1) {
                            modifierNames.push(`${mod}Key`);
                        }
                    });

                    correctModifiers = (event) => _.every(modifierNames, (modifierName) => event[modifierName]);
                }
            }

            const handler = (event) => {
                if (event.keyCode === keycode && (!modifiers || correctModifiers(event))) {
                    callback.call(context, event);
                }
            };

            if (selector) {
                win.on(type, selector, handler);
            } else {
                win.on(type, handler);
            }

            // Save a reference to the generated handler function so we can use it in the off() call.
            listeners.push({
                type,
                keycode,
                callback,
                handler,
                context,
                selector
            });
        };
    }

    function setupOff(type) {
        return function(keycode, callback, context) {
            // keycode and callback are always null when using listenTo() in views.

            const currentListeners = listeners.filter((listener) =>
                listener.type === type &&
                    (listener.context === context ||
                        (listener.keycode === keycode && listener.callback === callback)));

            currentListeners.forEach((listener) => {
                if (listener.selector) {
                    win.off(type, listener.selector, listener.handler);
                } else {
                    win.off(type, listener.handler);
                }
            });

            listeners = _.difference(listeners, currentListeners);
        };
    }

    /**
     * Utility class for listening to keyboard events with automatic cleanup.
     *
     * Usage:
     * this.listenTo(Keyboard, KeyCode.BLAH, function (event) { ... });
     *
     * Defaults to listening for keyup, use Keyboard.Down if you need keydown.
     *
     * @author Bo Gotthardt
     * @class Keyboard
     */
    return {
        on: setupOn("keyup"),
        off: setupOff("keyup"),

        Down: {
            on: setupOn("keydown"),
            off: setupOff("keydown")
        },

        KeyCode,

        Shortcut: Mousetrap
    };
});



// WEBPACK FOOTER //
// ./src/editor/services/Keyboard.js